import { Signal } from "signals";
import Logger from "slotworks/utils/logger";

class SmartUIFlags {

    public onFlagsUpdated: Signal = new Signal();

    public bitmask: number = 0;

    public init() {
        this.update();
    }

    public set(flag: SmartUIFlag, value: boolean) {
        if (value) {
            this.bitmask |= flag;
        } else {
            this.bitmask &= ~flag;
        }

        this.update();
    }

    public has(flags: SmartUIFlag | SmartUIFlag[]): boolean {
        if (Array.isArray(flags)) {
            flags = flags.reduce((all, one) => all |= one, 0);
        }
        return (this.bitmask & flags) === flags;
    }

    public maskToString(mask: number) {
        const flags: string[] = [];

        const smartFlags = Object.keys(SmartUIFlag).filter((key) => isNaN(Number(key)));

        smartFlags.forEach((key: string) => {
            const flag = (SmartUIFlag as any)[key] as number;

            if ((mask & flag) === flag) {
                flags.push(key);
            }
        });

        return flags.toString();
    }

    private update() {
        this.log(this.bitmask.toString());
        this.onFlagsUpdated.dispatch(this.bitmask);
    }

    private log(message: string) {
        Logger.info("%c SmartUIFlags ", "background: #ffccff; color: #fff", message);
    }
}

export default new SmartUIFlags();

export enum SmartUIFlag {
    ALWAYS = 0, // Always true
    IDLE = 1, // Game is idle
    NO_SKIP = 2, // Skip is disabled
    SKIP_COOLDOWN = 4, // Waiting for skip button to be enabled again
    FREE_SPINS = 8, // Game is freespinning
    BONUS = 16, // Bonus is playing
    AWAITING_RESPONSE = 32, // Awaiting server response
    AUTO_SPIN = 64, // Autospinning
    REPLAY = 128, // Not used
    PROMPT = 256, // Prompt is open
    MENU = 512, // Internal menu is open
    FREE_BETS = 1024, // In a free bet promotion
    AUTO_SPIN_SELECT = 2048, // Autospin menu is open
    GAMBLE = 4096, // Gamble is enabled
    GAMBLE_UI = 8192, // Gamble is open
    EXTERNAL_DISABLE = 32768, // Wrapper or similar is trying to disable the game
    NEVER = 16384 // Never true
}
